import metaTags from "./metaTags";

type tagType = (typeof metaTags)[0];

export const getTags = (location?: string): tagType | undefined => {
  const tag = metaTags.find((tag) => {
    return tag.Page === location;
  });

  return tag;
};

export const faqs = [
  {
    link: "/services/house-cleaning",
    questions: [
      {
        question: "How long will my cleaning take?",
        answer:
          "The cleaning process is various and can be checked at check-out."
      },
      {
        question: "Is your cleaning methods safe for children and pets?",
        answer: "We only use eco-friendly products, which are safe for all."
      },
      {
        question: "What is included in a standard house cleaning service?",
        answer:
          "A standard house cleaning service usually includes dusting, wiping surfaces, vacuuming, mopping floors, cleaning bathrooms, and general tidying of living spaces. The exact tasks may vary depending on the size of the home and the service booked."
      },
      {
        question: "Do I need to be at home during the cleaning?",
        answer:
          "No, you do not always need to be at home during the cleaning. Many customers choose to provide access in advance, but being present is optional as long as entry arrangements are confirmed beforehand."
      },
      {
        question: "Do you bring your own cleaning supplies and equipment?",
        answer:
          "Yes. Professional house cleaning services typically provide their own cleaning supplies and equipment, allowing the job to be completed efficiently without requiring homeowners to prepare products or tools."
      },
      {
        question: "How can I book a house cleaning service?",
        answer:
          "House cleaning services can usually be booked online, by phone, or email. Customers can choose their preferred service, date, and time based on availability."
      },
      {
        question: "Can I book a house cleaning service on weekends?",
        answer:
          "Yes. Weekend house cleaning appointments are often available, depending on scheduling and location. This provides flexibility for customers who prefer cleaning outside regular weekday hours."
      }
    ]
  },
  {
    link: "/services/End-Of-Tenancy-Cleaning",
    questions: [
      {
        question: "What is included in an end of tenancy cleaning service?",
        answer:
          "An end of tenancy cleaning service includes kitchen cleaning (appliance cleaning not included), sitting room cleaning, 1 bedroom cleaning, hallway cleaning, 1 bathroom cleaning, and cleaning of up to 20 interior windows up to 1.5 square meters. This service is designed to refresh the property and prepare it for the next tenant or inspection."
      },
      {
        question: "How long does an end of tenancy clean take?",
        answer:
          "The time required depends on the size and condition of the property. Standard properties may take a few hours, while larger homes or properties needing additional services may take longer."
      },
      {
        question: "Do I need to be present during the end of tenancy cleaning?",
        answer:
          "No, you do not need to be present during the cleaning as long as access has been arranged in advance. This allows the cleaning team to complete the service while you focus on moving or other priorities."
      },
      {
        question: "Do you bring your own cleaning equipment and supplies?",
        answer:
          "Yes. Professional house cleaning services typically provide their own cleaning supplies and equipment, allowing the job to be completed efficiently without requiring homeowners to prepare products or tools."
      },
      {
        question: "How much does end of tenancy cleaning cost?",
        answer:
          "The cost of end of tenancy cleaning depends on the property size, overall condition, and any additional cleaning services required beyond the standard package. Extra rooms or specialised services may affect the final price."
      }
    ]
  },

  {
    link: "/services/Kitchen",
    questions: [
      {
        question: "What is a kitchen cleaning service?",
        answer:
          "Our kitchen deep clean bundle includes a thorough cleaning of all kitchen appliances."
      },
      {
        question: "Why should I hire a kitchen cleaning service?",
        answer:
          "Saving time and getting a more thorough deep clean of the kitchen."
      },

      {
        question:
          "What is included in a professional kitchen cleaning service?",
        answer:
          "A professional kitchen deep cleaning service includes oven deep cleaning (single or double standard ovens), hob cleaning (electric or gas), extractor fan cleaning, fridge steam cleaning (must be emptied), kitchen cupboard cleaning (inside included if empty), microwave cleaning, blind or curtain plus internal window cleaning, floor cleaning with a polishing machine or steamer, and full surface plus skirting board cleaning."
      },
      {
        question:
          "Do you clean inside kitchen appliances like ovens and fridges?",
        answer:
          "Yes. Kitchen deep cleaning includes inside oven cleaning, fridge steam cleaning (when emptied beforehand), microwave cleaning, and cleaning of other key kitchen appliances included in the package."
      },
      {
        question: "How often should I book a kitchen cleaning service?",
        answer:
          "This depends on how often your kitchen is used. Busy households may benefit from more regular kitchen deep cleans, while occasional professional cleaning can help maintain hygiene, appliance condition, and overall cleanliness."
      },
      {
        question:
          "Do you remove grease and stubborn stains from kitchen surfaces?",
        answer:
          "Yes. Professional kitchen cleaning is designed to remove grease, food residue, and stubborn stains from ovens, hobs, extractor fans, cupboards, floors, and kitchen surfaces using suitable equipment and cleaning methods."
      },
      {
        question: "Can I book a one-off kitchen deep cleaning service?",
        answer:
          "Yes. A one-off kitchen deep cleaning service can be booked for a full kitchen refresh, whether for regular maintenance, moving house, post-renovation cleaning, or when your kitchen needs extra attention."
      }
    ]
  },

  {
    link: "/services/oven-kitchen-cleaning",
    questions: [
      {
        question: "Why is it important to clean my oven regularly?",
        answer:
          "If the oven is left uncleaned, it can lead to smoke or bad odors."
      },
      {
        question: "What are the signs that my oven needs cleaning?",
        answer: "Stuck food, smoke and bad odors after cooking."
      },

      {
        question: "What is included in a professional oven cleaning service?",
        answer:
          "A professional oven cleaning service includes deep cleaning of the oven interior, oven door removal and careful disassembly, glass cleaning, stain removal from interior and exterior glass surfaces, eco-friendly treatment of internal surfaces, residue removal, reassembly, and final inspection. One baking tray is included. Hobs and heating elements are not included."
      },
      {
        question: "How long does a professional oven clean take?",
        answer:
          "The time required depends on the oven’s size and condition. Ovens with heavier grease and grime build-up may take longer, while standard cleans are usually completed more quickly."
      },
      {
        question: "Do you clean single and double ovens?",
        answer:
          "Yes. Professional oven cleaning services can cover both single and double ovens, depending on the service booked."
      },
      {
        question: "Are the cleaning products safe for my oven?",
        answer:
          "Yes. Eco-friendly cleaning products are used to safely break down grease and grime while protecting your oven’s surfaces and functionality."
      },
      {
        question: "Can I book a one-off oven cleaning service?",
        answer:
          "Yes. One-off oven cleaning services are available for customers who want to restore their oven without scheduling regular appointments. This is ideal for seasonal cleaning, moving house, or tackling built-up grease."
      }
    ]
  },

  {
    link: "/services/bathroom-cleaning",
    questions: [
      {
        question: "Why should I hire a professional bathroom cleaning service?",
        answer:
          "We provide steam cleaning to reach unreachable spots and remove 99.9% of bacteria."
      },
      {
        question: "How long does it take to clean a bathroom professionally?",
        answer: "It will roughly take from 1-3 hours."
      },

      {
        question: "What is included in a bathroom cleaning service?",
        answer:
          "A professional bathroom deep cleaning service includes tile and wall steam cleaning, bath or shower cabin deep cleaning, sink steam cleaning, toilet steam cleaning, mirrors and cupboard cleaning, floor grout cleaning, and interior window cleaning. Kärcher steam equipment is used to reach difficult areas such as tap corners, shower sliders, and grout lines."
      },
      {
        question: "Do you remove mould and limescale?",
        answer:
          "Limescale removal is included as part of the bathroom deep cleaning service. Small mould spots may be treated where possible, but larger mould-affected walls or extensive mould treatment usually require an additional specialised service."
      },
      {
        question: "How long does a bathroom cleaning take?",
        answer:
          "The time required depends on the size and condition of the bathroom. Bathrooms with heavier limescale, grime, or additional problem areas may take longer than standard deep cleans."
      },
      {
        question: "Can I book bathroom cleaning as a one-off service?",
        answer:
          "Yes. Bathroom cleaning can be booked as a one-off deep cleaning service, making it ideal for regular maintenance, move-ins, move-outs, or when your bathroom needs extra attention."
      },
      {
        question: "Do you bring your own cleaning equipment and products?",
        answer:
          "Yes. Professional bathroom cleaning services include all necessary cleaning equipment and products, including specialised steam cleaning tools, so there is no need to provide anything yourself."
      }
    ]
  },
  {
    link: "/services/upholstery-cleaning",
    questions: [
      {
        question: "What is upholstery cleaning?",
        answer:
          "Upholstery cleaning is the process of cleaning the fabric on furniture or carpets using a special cleaner or detergent."
      },
      {
        question: "Can professional upholstery cleaners remove all stains?",
        answer:
          "Most of the time yes, but if the stain is left for 5+ years, it might not come off."
      },

      {
        question: "What upholstery items do you clean?",
        answer:
          "Professional upholstery cleaning can cover a range of furniture, including 2-seater sofas, 3-seater sofas, and 1-seater chairs as part of selected upholstery bundles. Cleaning focuses on removing debris, refreshing fabric, and improving the overall appearance of your upholstered furniture."
      },
      {
        question: "How long does upholstery take to dry?",
        answer:
          "Upholstery is usually left slightly damp after cleaning and drying time can vary depending on fabric type, ventilation, and room temperature. Keeping the heating on or ensuring good airflow can help speed up the drying process."
      },
      {
        question: "Is upholstery cleaning safe for all fabrics?",
        answer:
          "Professional upholstery cleaning is designed to be safe for many common upholstery fabrics when the correct methods and eco-friendly products are used. Fabric type and condition should always be considered before cleaning."
      },
      {
        question: "How often should upholstery be professionally cleaned?",
        answer:
          "Professional upholstery cleaning is generally recommended periodically depending on usage, pets, children, and overall wear. More frequently used furniture may benefit from more regular cleaning to maintain hygiene and appearance."
      },
      {
        question: "Can upholstery cleaning remove stains and odours?",
        answer:
          "Yes. Professional upholstery cleaning can help reduce stains, dirt, and odours by vacuuming debris, washing the fabric with eco-friendly cleaning products, and extracting moisture and dirt using specialist equipment. Results may vary depending on the type and age of the stain."
      }
    ]
  },

  {
    link: "/services/carpet-floor-cleaning",
    questions: [
      {
        question: "How often should I have my carpets professionally cleaned?",
        answer: "At least once a year."
      },
      {
        question: "What methods are used for carpet cleaning?",
        answer:
          "Vacumming, shampooing, and dry suctioning to take out the water left."
      },

      {
        question: "What is included in a professional carpet/floor cleaning?",
        answer:
          "Professional carpet and floor cleaning usually includes vacuuming, stain treatment, deep cleaning using specialised equipment, and removal of dirt, dust, and debris from carpets or hard floors. Depending on the service booked, floor polishing, steam cleaning, or deep extraction cleaning may also be included to help refresh and restore surfaces."
      },
      {
        question: "What methods are used for carpet cleaning?",
        answer:
          "Professional carpet cleaning can include several methods depending on the carpet type and level of dirt. Common methods include steam cleaning, hot water extraction, deep vacuuming, stain treatment, and low-moisture cleaning. The most suitable method is usually chosen based on the carpet’s material and condition."
      },
      {
        question: "Is carpet/floor cleanign safe for all fabrics?",
        answer:
          "Professional carpet and floor cleaning is designed to be safe for most carpet materials and flooring types when the correct cleaning methods and products are used. Different fabrics and surfaces may require different treatments, so the cleaning approach is usually selected based on the material and overall condition."
      },
      {
        question: "How long does it take for the carpet to dry?",
        answer:
          "Drying time depends on the carpet type, cleaning method, airflow, and room temperature. Carpets are usually left slightly damp after cleaning and may take several hours to dry fully. Keeping windows open or heating on can help speed up the drying process."
      },
      {
        question:
          "Can professional carpet cleaning remove stubborn stains and pet odours?",
        answer:
          "Yes. Professional carpet cleaning can help reduce stubborn stains, dirt, and pet odours using deep cleaning equipment and suitable cleaning products. Results may vary depending on the type of stain, how long it has been there, and the carpet material."
      }
    ]
  },

  {
    link: "/services/window-cleaning",
    questions: [
      {
        question: "Why should I hire a professional window cleaning service?",
        answer: "Save time and have better results."
      },
      {
        question:
          "How long will my windows stay clean after a professional cleaning?",
        answer: "4-6 weeks after the cleaning process."
      },

      {
        question: "What is included in a professional window cleaning service?",
        answer:
          "A professional window cleaning service usually includes cleaning interior windows, exterior windows, window frames, and sills depending on the service booked. The cleaning focuses on removing dust, dirt, water marks, and other build-up to leave windows clear and streak-free."
      },
      {
        question: "Do you clean both the inside and outside of the windows?",
        answer:
          "Yes. Window cleaning services can include both interior and exterior window cleaning depending on the package booked. Customers can also choose inside-only or outside-only cleaning if preferred."
      },
      {
        question: "How often should I have my windows professionally cleaned?",
        answer:
          "The ideal frequency depends on the property location, weather conditions, and how quickly dirt builds up. Many homeowners choose professional window cleaning every few months to keep windows clear, bright, and well maintained."
      },
      {
        question: "Do you clean window frames, sills, and screens?",
        answer:
          "Yes. Professional window cleaning includes cleaning window frames, sills, and screens to help remove dust, dirt, and build-up for a more complete and refreshed finish."
      },
      {
        question:
          "What equipment and cleaning solutions do you use for window cleaning?",
        answer:
          "We use professional squeegees, microfiber cloths, extension poles, and purified water systems, along with safe glass cleaning solutions to ensure a streak-free finish."
      }
    ]
  },

  {
    link: "/services/powerwashing-services",
    questions: [
      {
        question: "What is power washing?",
        answer:
          "Powerwashing is to remove any dirt, grime, weeds, algae, and mud from an outside surface, transforming it to brand new."
      },
      {
        question:
          "What is the difference between power washing and pressure washing?",
        answer:
          "Power washing uses soap and hot water; pressure washing uses cold water."
      },

      {
        question: "What is included in a professional powerwashing service?",
        answer:
          "A professional powerwashing service includes cleaning exterior surfaces such as driveways, patios, walls, and pathways using high-pressure water equipment. It removes built-up dirt, moss, algae, and stains to restore the surface’s original look."
      },
      {
        question: "What surfaces can be safely powerwashed?",
        answer:
          "Most durable exterior surfaces can be safely powerwashed, including driveways, patios, paving, concrete, brick, and exterior walls. Delicate surfaces may require lower pressure or alternative cleaning methods."
      },
      {
        question: "Will powerwashing damage my driveway or patio?",
        answer:
          "When done correctly by professionals, powerwashing will not damage your driveway or patio. We adjust pressure and methods depending on the surface to ensure a safe and effective clean."
      },
      {
        question:
          "Do you use eco-friendly cleaning solutions during powerwashing?",
        answer:
          "Yes, where needed we use eco-friendly, biodegradable cleaning solutions that are safe for surrounding plants, pets, and outdoor areas."
      },
      {
        question: "How often should I powerwash the exterior of my home?",
        answer:
          "Typically once a year is recommended, but high-traffic or shaded areas may benefit from cleaning every 6–9 months depending on buildup."
      }
    ]
  },

  {
    link: "/services/Roof-Cleaning",
    questions: [
      {
        question: "What is included in professional roof cleaning?",
        answer:
          "Professional roof cleaning includes removing moss, algae, lichen, and built-up debris from roof tiles using safe, low-pressure methods and appropriate treatments to prevent regrowth."
      },
      {
        question: "Is roof cleaning safe for my roof tiles or shingles?",
        answer:
          "Yes, roof cleaning is carried out using safe, low-pressure methods and suitable treatments designed to protect tiles or shingles while effectively removing moss and dirt."
      },
      {
        question: "How do you remove moss and algae from the roof?",
        answer:
          "We remove moss and algae using safe scraping or soft-wash methods, followed by an appropriate treatment to clean the surface and help prevent regrowth."
      },
      {
        question: "Do you use high-pressure washing or soft washing for roofs?",
        answer:
          "We use soft washing for roofs, along with low-pressure techniques and suitable treatments to safely clean and protect the tiles."
      },
      {
        question: "How often should I have my roof professionally cleaned?",
        answer:
          "Typically every 1–3 years, depending on the amount of moss, algae, and surrounding trees or weather exposure."
      }
    ]
  },

  {
    link: "/services/Chimney-Cleaning",
    questions: [
      {
        question: "Why is chimney cleaning important?",
        answer:
          "A clean chimney means a safer, more efficient fireplace and home heating appliance."
      },
      {
        question: "How often should I have my chimney cleaned?",
        answer: "At least once a year."
      },

      {
        question: "What is included in professional chimney cleaning service?",
        answer:
          "A professional chimney cleaning service includes removing soot, creosote, and blockages from the chimney flue to ensure safe and efficient airflow."
      },
      {
        question: "How often should my chimney be swept or cleaned?",
        answer:
          "Generally once a year, or more often if the fireplace or stove is used frequently."
      },
      {
        question: "Does chimney cleaning create a mess inside my house?",
        answer:
          "No, we use protective sheets and specialist equipment to contain soot and debris, keeping your home clean during the service."
      },
      {
        question:
          "Do you perform a chimney inspection during the cleaning process?",
        answer:
          "Yes, a basic visual inspection is carried out during cleaning to check for blockages, soot buildup, and any obvious issues with the flue."
      },
      {
        question: "How long does a standard chimney cleaning take?",
        answer:
          "A standard chimney cleaning usually takes around 30–60 minutes, depending on the condition and level of soot buildup."
      }
    ]
  },

  {
    link: "/services/Mould_walls",
    questions: [
      {
        question: "What is mould treatment?",
        answer:
          "Using industrial-based chemicals, we completely kill away the mould present."
      },
      {
        question: "How do I know if I have mould in my home?",
        answer: "Black spots and damp smell."
      },

      {
        question:
          "What is included in professional mould and wall cleaning service?",
        answer:
          "A professional mould and wall cleaning service includes removing visible mould, treating affected areas with appropriate solutions, and cleaning walls to help reduce regrowth and improve surface appearance."
      },
      {
        question: "What causes mould to grow on walls and ceilings?",
        answer:
          "Mould usually grows due to excess moisture, poor ventilation, condensation, or leaks. It’s most common in bathrooms, kitchens, and poorly ventilated rooms."
      },
      {
        question:
          "Are the chemicals used for mould removal safe for pets and children?",
        answer:
          "We use professional, safety-approved treatments and ensure areas are properly ventilated and dried after cleaning. Once dry, they are safe for pets and children."
      },
      {
        question:
          "Will the mould come back after it is professionally removed?",
        answer:
          "It can return if the underlying moisture or ventilation issue isn’t fixed, but our treatment helps reduce regrowth and slow it down significantly."
      },
      {
        question:
          "Do you help identify the source of the moisture causing the mould?",
        answer:
          "Yes, we can usually identify common moisture sources like condensation, leaks, or poor ventilation and advise on how to reduce the risk of mould returning."
      }
    ]
  },

  {
    link: "/services/Airbnb_Office",
    questions: [
      {
        question: "What does a typical office cleaning service include?",
        answer:
          "Office cleaning includes maintaining a clean and healthy environment."
      },
      {
        question: "Why should I hire a professional office cleaning service?",
        answer:
          "Our office cleaning is very comfortable for every office personal, because we include VAT and no contracts are needed to hire cleaners."
      }
    ]
  },

  {
    link: "/services/Afterrenovationcleaning",
    questions: [
      {
        question: "How long does after renovation cleaning take?",
        answer: "Cleaning one room would take approximately one hour."
      },
      {
        question: "What does after renovation cleaning typically include?",
        answer:
          "A room may appear pristine and refreshed, but often there is a layer of dust, debris, and residue left behind that requires thorough cleaning."
      }
    ]
  },

  {
    link: "/services/handyman-service",
    questions: [
      {
        question: "Do I need to provide my own materials for the job?",
        answer:
          "The best choice is to provide your own materials so you know exactly what you are getting put in or fixed."
      },
      {
        question: "How do I schedule a handyman service?",
        answer:
          "The best way to schedule a handyman is online or via email at hello@cleanbee.ie."
      }
    ]
  },

  {
    link: "/services/Painting",
    questions: [
      {
        question: "Why should I hire a professional for wall painting?",
        answer: "Professional painters ensure a high-standard painting service."
      },
      {
        question: "How do I prepare my walls for painting?",
        answer:
          "Some walls don't need to be prepared. If you are unsure if you need to prepare a wall for painting, get in contact with us via email at hello@cleanbee.ie."
      }
    ]
  },

  {
    link: "/services/Car_Cleaning",
    questions: [
      {
        question: "What types of car cleaning services are available?",
        answer: "Regular-sized cars (5 seaters) and Jeep cars (7 seaters)."
      },
      {
        question:
          "What is the difference between car washing and car detailing?",
        answer: "Car washing is only to touch up the car"
      }
    ]
  }
];
